import produce, { Draft } from 'immer';
import { useState, useCallback } from 'react';

export type Producer<S> = (draft: Draft<S>) => void | S;
export type Produce<S> = (producer: Producer<S>) => void;

// The following two are copied from React
type SetStateAction<S> = S | ((prevState: S) => S);
type Dispatch<A> = (value: A) => void;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useImmer<S = any>(
  initialValue: S | (() => S),
): [S, Produce<S>, Dispatch<SetStateAction<S>>] {
  const [value, setValue] = useState(initialValue);
  const update: Produce<S> = useCallback((updater) => {
    setValue(produce(updater) as S);
  }, []);
  return [value, update, setValue];
}
